import React from  'react'
import {MusicIcon} from 'components/vectors'
import PropTypes from 'prop-types'


const ArtisteListItem = props => {
    const { name, handleClick, error } = props
    return(
     error ? (
         <li className="filter-list-item">
            <div className="d-flex flex-row align-items-center">
                <div>
                    <p className="text--xs-bold text--black mt-1">You have not been assinged this artist. Kindly contact administrator.</p>
                </div>
            </div>
        </li>
     ) : (
         <li className="filter-list-item" onClick={() => handleClick(name)} onMouseDown={ () => handleClick(name)}>
            <div className="d-flex flex-row align-items-center">
                <div className="filter-icon__container">
                <MusicIcon width="16" height="16" />
                </div>
                
                <div>
                    <p className="text--small-bold text--black">{name}</p>
                    <p className="text--xs text--grey mt-1">Musician</p>
                </div>
            </div>
        </li>
     )
)}

// ArtisteListItem.defaultProps = {
//     name: 'Unknown'
// }

ArtisteListItem.prototype = {
    name: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired
}

export default ArtisteListItem;